import { render, staticRenderFns } from "./ManualExitTransaction.vue?vue&type=template&id=1708785d&"
import script from "./ManualExitTransaction.vue?vue&type=script&lang=js&"
export * from "./ManualExitTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports